import { merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";
import { serialize } from "object-to-formdata";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "organization";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    get: (id) => [`${prefix}/profile/${namespace}/${id}`],
    checkVat: (vat) => [`${prefix}/profile/${namespace}/checkvat/${vat}`],
    getOrganizationFromLoggedUser: () => [`${prefix}/profile/${namespace}`],
    getOrganizationFiles: (id) =>  [`${prefix}/happyway/repository-objects?entity_id=${id}&entityType=Organization`]
  },
  post: {
    register: (data) => [`${prefix}/profile/profile/registerorganization`, data],
    createUploadInstance: ({
      entity_id,
      entityType,
      file,
      meta
    }) => {
      return [`${prefix}/happyway/repository-objects/upload`, serialize({file, meta, entity_id, entityType}) ];
    },
  },
  put: {
    update: (id, data) =>  [`${prefix}/profile/${namespace}/${id}`, data],
  }
});

export default nameSpace;
